export default {"src":"/_next/static/media/star.5689da33.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};